export { SubstitutionGeneral } from "./substitution-general";
